var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_62_56663",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 80C160 91.8811 157.405 103.168 152.746 113.308C140.119 140.865 112.292 160 80 160C47.7081 160 19.8811 140.865 7.25405 113.308C2.59459 103.168 0 91.8811 0 80C0 35.8162 35.8162 0 80 0C124.184 0 160 35.8162 160 80Z",
    fill: "#E5F5F3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_62_56663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 112L30 106.5L52 115L32 126L3.5 112Z",
    fill: "#BFE4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5 112L130 106.5L108 115L128 126L156.5 112Z",
    fill: "#BFE4DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 115H108L128 126H32L52 115Z",
    fill: "#66C9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1047 67.4372C69.117 62.234 80.6409 65.3218 85.8441 74.3341C91.0473 83.3463 87.9595 94.8702 78.9472 100.073L68.3491 106.192L65.5044 118.939C65.1538 120.51 63.0555 120.832 62.2505 119.437L57.3551 110.958C49.9772 111.99 42.3735 108.563 38.4197 101.715C33.2164 92.7023 36.3043 81.1784 45.3165 75.9752L60.1047 67.4372Z",
    fill: "#BFE4DF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.94414,
    cy: 2.94414,
    r: 2.94414,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 73.1538 78.2612)",
    fill: "#66C9B9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.94414,
    cy: 2.94414,
    r: 2.94414,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 62.9546 84.1519)",
    fill: "#66C9B9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.94414,
    cy: 2.94414,
    r: 2.94414,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 52.7573 90.0386)",
    fill: "#66C9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6415 31.5819C78.287 28.0035 64.5601 35.9287 60.9818 49.2833C57.4034 62.6379 65.3286 76.3647 78.6832 79.9431L94.3899 84.1517L102.423 99.5306C103.414 101.427 106.217 101.118 106.77 99.0515L110.137 86.4866C119.959 85.2735 128.538 78.2608 131.257 68.1134C134.835 54.7588 126.91 41.032 113.555 37.4536L91.6415 31.5819Z",
    fill: "#66C9B9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.3845,
    cy: 54.7476,
    r: 3.9115,
    transform: "rotate(15 81.3845 54.7476)",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.4978,
    cy: 58.7984,
    r: 3.9115,
    transform: "rotate(15 96.4978 58.7984)",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.609,
    cy: 62.8492,
    r: 3.9115,
    transform: "rotate(15 111.609 62.8492)",
    fill: "#F4F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5943 43.7167C56.3999 43.5236 56.8965 42.7141 56.7034 41.9084C56.5104 41.1028 55.7008 40.6062 54.8952 40.7993L51.0053 41.7315C50.1997 41.9245 49.7031 42.7341 49.8961 43.5397C50.0892 44.3453 50.8988 44.8419 51.7044 44.6489L55.5943 43.7167ZM70.0168 25.4687C70.0152 26.2971 69.3423 26.9674 68.5139 26.9658C67.6855 26.9642 67.0152 26.2913 67.0168 25.4629L67.0246 21.4629C67.0262 20.6344 67.6991 19.9642 68.5276 19.9658C69.356 19.9674 70.0262 20.6403 70.0246 21.4687L70.0168 25.4687ZM57.4893 34.7267C57.3012 35.5334 56.4947 36.0349 55.6879 35.8468L51.7924 34.9384C50.9856 34.7502 50.4841 33.9437 50.6722 33.1369C50.8604 32.3301 51.6669 31.8286 52.4737 32.0168L56.3692 32.9252C57.176 33.1133 57.6775 33.9199 57.4893 34.7267ZM62.378 27.3801C62.7476 28.1216 62.4461 29.0222 61.7046 29.3917C60.9632 29.7612 60.0625 29.4597 59.693 28.7183L57.9088 25.1383C57.5392 24.3968 57.8407 23.4962 58.5822 23.1267C59.3236 22.7572 60.2242 23.0587 60.5938 23.8001L62.378 27.3801Z",
    fill: "#66C9B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 126,
    width: 96,
    height: 84,
    fill: "#BFE4DF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGroup);
export default __webpack_public_path__ + "static/media/chatGroup.0f850cd2.svg";
export { ForwardRef as ReactComponent };